import { createSelector } from '../reselect';
import { simpleChart2, getNewStatsService, simpleChart, total, safeDivide } from '../generalUtils';

const getNewStats = getNewStatsService('tiktok-ads');

const tiktokClicks = createSelector([getNewStats], (stats) => {
  return total(stats, 'clicks');
});

const tiktokClicksChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

const tiktokSpend = createSelector([getNewStats], (stats) => {
  return total(stats, 'spend');
});

const tiktokSpendChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

const tiktokConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const tiktokConversionValueChart = createSelector(
  [getNewStats, tiktokSpendChart],
  (stats, tiktokSpendChart) => {
    return simpleChart(stats, 'conversionValue');
  }
);

const tiktokImpressions = createSelector([getNewStats], (stats) => {
  return total(stats, 'impressions');
});

const tiktokImpressionsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'impressions');
});

const tiktokPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const tiktokPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'purchases');
});

const averageTiktokCpm = createSelector([tiktokImpressions, tiktokSpend], (impressions, spend) => {
  return safeDivide(spend, impressions / 1000);
});

const chartTiktokCpm = createSelector(
  [tiktokImpressionsChart, tiktokSpendChart],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const averageTiktokCpc = createSelector([tiktokClicks, tiktokSpend], (clicks, spend) => {
  return safeDivide(spend, clicks);
});

const chartTiktokCpc = createSelector([tiktokClicksChart, tiktokSpendChart], (clicks, spend) => {
  return simpleChart2(spend, clicks);
});

const tiktokCtr = createSelector([tiktokClicks, tiktokImpressions], (clicks, impressions) => {
  return safeDivide(clicks, impressions) * 100;
});

const chartTiktokCtr = createSelector(
  [tiktokClicksChart, tiktokImpressionsChart],
  (clicks, impressions) => {
    return simpleChart2(clicks, impressions, { chart1yMultiplier: 100 });
  }
);

const tiktokCpa = createSelector(
  [getNewStats, tiktokSpend, tiktokPurchases],
  (stats, spend, purchases) => {
    return safeDivide(spend, purchases);
  }
);

const tiktokCpaChart = createSelector(
  [getNewStats, tiktokSpendChart, tiktokPurchasesChart],
  (stats, spend, purchases) => {
    return simpleChart2(spend, purchases);
  }
);

const tiktokRoas = createSelector(
  [tiktokConversionValue, tiktokSpend],
  (tiktokConversionValue, tiktokSpend) => {
    return safeDivide(tiktokConversionValue, tiktokSpend);
  }
);

const tiktokRoasChart = createSelector(
  [getNewStats, tiktokConversionValueChart, tiktokSpendChart],
  (stats, conversionValue, spend) => {
    return simpleChart2(conversionValue, spend);
  }
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    tiktokClicks,
    tiktokClicksChart,
    tiktokSpend,
    tiktokSpendChart,
    tiktokConversionValue,
    tiktokConversionValueChart,
    tiktokImpressions,
    tiktokImpressionsChart,
    tiktokPurchases,
    tiktokPurchasesChart,
    averageTiktokCpm,
    chartTiktokCpm,
    averageTiktokCpc,
    chartTiktokCpc,
    tiktokCtr,
    chartTiktokCtr,
    tiktokCpa,
    tiktokCpaChart,
    tiktokRoas,
    tiktokRoasChart,
    tiktok_complete_payment_roas: tiktokRoas,
    tiktok_spend: tiktokSpend,
  },
};
